module.exports = __webpack_public_path__ + "static/media/P36.6d4ab867.png";